import { createContext, useContext } from "react";

/** Defaults supplied by the nearest `LinkController` for descendant `AppLink` components. */
export interface LinkControllerContextValue {
    suppress?: string;
    layout?: string;
    activateToggleSwitch?: string;
}

export const LinkControllerContext = createContext<LinkControllerContextValue | null>(null);

export function useLinkController(): LinkControllerContextValue | null {
    return useContext(LinkControllerContext);
}
